import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

// The feed's section rules: an ordered list of betweenComponentConfig entries,
// each `{ label, leading, join, conditions[] }` as authored, emitted at render
// time as the engine's shipped `{ template, context, visibilityExpression }`
// shape (app.schema.json $defs.betweenComponentConfig).
//
// Rules are evaluated per ADJACENT ROW PAIR: the first rule whose expression
// passes on a gap inserts its separator there. Declaration order is the tie
// break, matching RelatedEntityFeed#injectBetweenComponents.
export default class FeedSeparatorsRules extends BaseOption {
  static userInterfaceComponent = {
    component: inspectorTools.FEED_SEPARATORS_RULES,
  };

  static defaultValue = [];
}
